import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';

// Components
import { Box, Skeleton, Stack, TextField, useMediaQuery } from '@mui/material';
import { MDropdown } from 'common';
import MobileFilters from '../../../filters/MobileFilters';

const skeletons = (
  <>
    <Box mb={3}>
      <Skeleton borderradius={4} height={47} variant="rectangular" width="100%" />
    </Box>
    <Box mb={3}>
      <Skeleton borderradius={4} height={47} variant="rectangular" width="100%" />
    </Box>
  </>
);

const Filters = ({
  setActiveState,
  activeState,
  setSearchField,
  searchField,
  locationsPending,
  states,
}) => {
  const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'), { noSsr: true });

  const onFilter = e => setSearchField(e.target.value);

  const rwtFilters = (
    // eslint-disable-next-line sort-keys-fix/sort-keys-fix
    <Stack spacing={2} sx={{ height: { xs: 118, md: 0 }, width: 1 }}>
      {!!states.length && (
        <MDropdown
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          id="viewBy-select"
          items={states}
          label="State"
          name="state"
          onChange={({ value }) => setActiveState(value)}
          value={activeState}
        />
      )}
      <TextField label="Location" onChange={onFilter} placeholder="Filter" value={searchField} />
    </Stack>
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      // eslint-disable-next-line
      p={{ xs: (3, 3, 0), md: 3 }}
      width={1}
    >
      {locationsPending ? (
        skeletons
      ) : mdUp ? (
        rwtFilters
      ) : (
        <MobileFilters>{rwtFilters}</MobileFilters>
      )}
    </Box>
  );
};

export default Filters;

Filters.propTypes = {
  activeState: string.isRequired,
  locationsPending: bool.isRequired,
  searchField: string,
  setActiveState: func.isRequired,
  setSearchField: func.isRequired,
  states: arrayOf(shape({})).isRequired,
};

Filters.defaultProps = {
  searchField: '',
};
